import React from "react";

import destination_1 from "../../public/wheretogo-krkonose/zaly/destination_1.png";
import destination_2 from "../../public/wheretogo-krkonose/zaly/destination_2.png";
import destination_3 from "../../public/wheretogo-krkonose/zaly/destination_3.png";
import destination_4 from "../../public/wheretogo-krkonose/zaly/destination_4.png";
import destination_5 from "../../public/wheretogo-krkonose/zaly/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-krkonose/zaly/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-krkonose/zaly/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-krkonose/zaly/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-krkonose/zaly/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Zaly = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Žalý</h1>
            <p>
              Vrchol kopce Přední Žalý (1019 m n. m.) mezi Beneckem a Vrchlabím
              patřil od počátku 19. století k oblíbenému turistickému cíli.
              Nachází se zde i kamenná rozhledna, ze které je skutečně dobrý
              rozhled, a to i na Krkonoše.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>1019 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>rozhledna</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistická chata</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>výhled na krkonoše</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Rozhlednu Žalý nechal postavit v roce 1892 hrabě Harrach.
                </li>
                <li>
                  První jednoduchá dřevěná rozhledna, či spíše zaměřovací bod,
                  zde byla vystavěna roku 1836. Oblíbenou vyhlídku přerostl les
                  a roku 1888 zřídil spolek Riesengebirge-Verein z Vrchlabí
                  kovovou montovanou rozhlednu o výšce 15 metrů.
                </li>
                <li>
                  Roku 1900 původní restaurace vyhořela a na jejím místě vznikla
                  nová dřevěná restaurace, která sem byla přenesena z Jubilejní
                  zemské výstavy v Praze. Tato restaurace zanikla během 2.
                  světové války a na jejím místě byla v roce 2009 vystavěna
                  kopie restaurace podle projektu arch. Klose.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Zaly;
